import { isEmpty } from "../_utils/validators.js";
import { apiFetch } from "../_utils/apiInterceptor.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = `${backendUrl}/api/v1/access`;

export const getProfiles = async () => {
    return await apiFetch(
      `${BASE_URL}/get-profiles`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
};

export const getAccess = async (accessId) => {
  
  if (isEmpty(accessId)) {
    throw new Error("Validation Error: Invalid access ID.");
  }
  return await apiFetch(
    `${BASE_URL}/get-access`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ accessId }),
    }
  );
};